<ins-placemark-submenu-content class="SubMenuContent" [class.opened]="menuOpened" [isOpen]="menuOpened" [createAtCenter]="true" [showMoveObjectLink]="(isPermEdit3d || isPermEditPm) && sceneMode == SCENE_MODE.Facility"
(actionClicked)="menuOpened = false"></ins-placemark-submenu-content>
@if (isPermPlacemark || ((isPermEdit3d || isPermEditPm) && sceneMode == SCENE_MODE.Facility)) {
  <div id="placemarkMenuBtn" class="SubMenuButton topRightRoundCorner" [class.pressed]="menuOpened" (click)="toggleMenu()">
    <mat-icon class="subMenuArrow" svgIcon="arrow.submenu"></mat-icon>
    <mat-icon class="subMenuIcon" [class.pressed]="menuOpened" svgIcon="add.placemark.submenu"></mat-icon>
    <div>Placemark</div>
  </div>
}
